import React, { useEffect, useState } from 'react';
import {
    getSubscriptionInactiveDaysSagaAction,
    updateEstablishmentSagaAction,
    updateSubscriptionInactiveDaysSagaAction,
    uploadFileSagaAction
} from "../../redux/sagaActions";
import TextareaAutosize from "react-textarea-autosize";
import { useDispatch, useSelector } from "react-redux";
import { subscriptionInactiveDaysAction, uploadFileAction, docsAction, selectAction } from "../../redux/rootReducer";
import Tippy from "@tippyjs/react";
import growl from "../../lib/growl/growl";
import Select from "../Select/Select";
import { SELECT_INITIAL } from "../../redux/initialStateConstant";

// Слаг заведения
let s = '';

const EstablishmentSettings = () => {
    const dispatch = useDispatch();
    const establishmentList = useSelector(state => state.establishmentList);
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const subscription_inactive_days = useSelector(state => state.subscription_inactive_days);
    const docs = useSelector(state => state.docs);
    const upload_file = useSelector(state => state.upload_file);

    const initialEst = {
        id: '',
        name: '',
        schedule: {
            mon_from: '', mon_to: '',
            tue_from: '', tue_to: '',
            wed_from: '', wed_to: '',
            thu_from: '', thu_to: '',
            fri_from: '', fri_to: '',
            sat_from: '', sat_to: '',
            sun_from: '', sun_to: ''
        },
        address: '',
        coords: { lat: '0', lng: '0' },
        description: '',
        phones: [],
        social_networks: {
            vk: '',
            instagram: '',
            youtube: ''
        },
        attendance: '0',
        points_rate: '',
        requisites: '',
        online_payment_service: '',
        online_payment_store_id: '',
        online_payment_secret_key: '',
        time_to_unsubscribe: '',
        widget: '',
        docs: [],
        extension_days: '0',
        workout_debt_count: '0',
        missed_workout_count: 0
    };

    const [est, setEst] = useState(initialEst);

    const readFile = ({ input, id }) => {

        // Ссылка на читаемый файл
        let file = input.target.files[0];

        if (!file) return false;

        // Создаём ссылку на FileReader
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {

            if (id === 'add') {
                dispatch(uploadFileSagaAction({ file, id: 'add' }));
            }
            else if (Number.isInteger(id)) {
                dispatch(uploadFileSagaAction({ file, id }));
            }
        };
    };

    // Получение сроков активации для неактивированных абонементов (только при первой отрисовке)
    useEffect(() => {
        dispatch(getSubscriptionInactiveDaysSagaAction());
    }, []);

    useEffect(() => {

        if (!currentEstablishment && !establishmentList.length) return;

        let currentEst = { ...establishmentList.find(el => el.id === currentEstablishment) };

        if (!currentEst.id) return;

        // Парсим координаты, телефоны и расписание
        if (currentEst?.phones?.length && typeof currentEst.phones === 'string') {
            currentEst.phones = JSON.parse(currentEst.phones);
        }
        else if (typeof currentEst.phones !== 'object') {
            currentEst.phones = initialEst.phones;
        }
        if (currentEst?.coords?.length && typeof currentEst.coords === 'string') {
            currentEst.coords = JSON.parse(currentEst.coords);
        }
        else if (typeof currentEst.coords !== 'object') {
            currentEst.coords = initialEst.coords;
        }
        if (currentEst?.schedule?.length && typeof currentEst.schedule === 'string') {
            currentEst.schedule = JSON.parse(currentEst?.schedule);
        }
        else if (typeof currentEst.schedule !== 'object') {
            currentEst.schedule = initialEst.schedule;
        }
        if (currentEst?.social_networks?.length && typeof currentEst.social_networks === 'string') {
            currentEst.social_networks = JSON.parse(currentEst.social_networks);
        }
        else if (typeof currentEst.social_networks !== 'object') {
            currentEst.social_networks = initialEst.social_networks;
        }

        dispatch(docsAction(currentEst.docs));

        setEst(currentEst);

        // Получаем слаг
        let widget_path = currentEst.widget;
        s = widget_path.replace('https://alga.by/fitness_widget?sl=', '');
        s = s.replace(`&est=${ currentEstablishment }`, '');

    }, [establishmentList, currentEstablishment]);

    if (!est) return false;

    return (
        <div className="settings settings--without-right-padding">
            <div className="setting">
                <div className="setting__caption">Название заведения</div>
                <input type="text" className="input" value={ est.name } onInput={ event => {
                    setEst({
                        ...est,
                        name: event.target.value
                    });
                } } onBlur={ () => {
                    dispatch(updateEstablishmentSagaAction({ field: 'name', value: est.name }));
                } } />
            </div>
            <div className="setting">
                <div className="setting__caption">Время работы</div>
                <div className="worktime">
                    <div className="worktime__day">Понедельник</div>
                    <div className="worktime__time">
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.mon_from }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       mon_from: event.target.value
                                   }
                               })}
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                        <div className="worktime__delimiter">−</div>
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.mon_to }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       mon_to: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                    </div>
                </div>
                <div className="worktime">
                    <div className="worktime__day">Вторник</div>
                    <div className="worktime__time">
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.tue_from }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       tue_from: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                        <div className="worktime__delimiter">−</div>
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.tue_to }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       tue_to: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                    </div>
                </div>
                <div className="worktime">
                    <div className="worktime__day">Среда</div>
                    <div className="worktime__time">
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.wed_from }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       wed_from: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                        <div className="worktime__delimiter">−</div>
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.wed_to }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       wed_to: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                    </div>
                </div>
                <div className="worktime">
                    <div className="worktime__day">Четверг</div>
                    <div className="worktime__time">
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.thu_from }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       thu_from: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                        <div className="worktime__delimiter">−</div>
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.thu_to }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       thu_to: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                    </div>
                </div>
                <div className="worktime">
                    <div className="worktime__day">Пятница</div>
                    <div className="worktime__time">
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.fri_from }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       fri_from: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                        <div className="worktime__delimiter">−</div>
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.fri_to }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       fri_to: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                    </div>
                </div>
                <div className="worktime">
                    <div className="worktime__day">Суббота</div>
                    <div className="worktime__time">
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.sat_from }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       sat_from: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                        <div className="worktime__delimiter">−</div>
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.sat_to }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       sat_to: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                    </div>
                </div>
                <div className="worktime">
                    <div className="worktime__day">Воскресенье</div>
                    <div className="worktime__time">
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.sun_from }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       sun_from: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                        <div className="worktime__delimiter">−</div>
                        <input type="time" className="input worktime__value"
                               value={ est.schedule.sun_to }
                               onInput={ event => setEst({
                                   ...est,
                                   schedule: {
                                       ...est.schedule,
                                       sun_to: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({ field: 'schedule', value: JSON.stringify(est.schedule) }));
                               } }
                        />
                    </div>
                </div>
            </div>
            <div className="setting">
                <div className="setting__caption">Адрес</div>
                <input type="text" className="input" value={ est.address }
                       onInput={ event => setEst({
                           ...est,
                           address: event.target.value
                       }) }
                       onBlur={ () => {
                           dispatch(updateEstablishmentSagaAction({ field: 'address', value: est.address }));
                       } }
                />
            </div>
            <div className="setting">
                <div className="setting__caption">Координаты</div>
                <div className="settings__flex">
                    <div className="settings__flex-item">
                        <div className="input__caption">Широта</div>
                        <input type="text" className="input" value={ est.coords.lat }
                               onInput={ event => setEst({
                                   ...est,
                                   coords: {
                                       lat: event.target.value,
                                       lng: est.coords.lng
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({
                                       field: 'coords',
                                       value: JSON.stringify(est.coords)
                                   }));
                               } }
                        />
                    </div>
                    <div className="settings__flex-item">
                        <div className="input__caption">Долгота</div>
                        <input type="text" className="input" value={ est.coords.lng }
                               onInput={ event => setEst({
                                   ...est,
                                   coords: {
                                       lat: est.coords.lat,
                                       lng: event.target.value
                                   }
                               }) }
                               onBlur={ () => {
                                   dispatch(updateEstablishmentSagaAction({
                                       field: 'coords',
                                       value: JSON.stringify(est.coords)
                                   }));
                               } }
                        />
                    </div>
                </div>
            </div>
            <div className="setting">
                <div className="setting__caption">Описание</div>
                <TextareaAutosize
                    className="input input--textarea"
                    value={ est.description }
                    onInput={ event => setEst({
                        ...est,
                        description: event.target.value
                    })}
                    onBlur={ () => {
                        dispatch(updateEstablishmentSagaAction({ field: 'description', value: est.description }));
                    } }
                />
            </div>
            <div className="setting">
                <div className="setting__caption">Телефоны</div>
                {
                    est.phones.map((phone, index) => {
                        return (
                            <div className="setting__phone-wrapper" key={ index }>
                                <input className="input setting__phone" value={ phone } onBlur={ event => {
                                    let newPhones = [...est.phones];
                                    newPhones[index] = event.target.value;

                                    dispatch(updateEstablishmentSagaAction({
                                        field: 'phones',
                                        value: JSON.stringify(newPhones)
                                    }));
                                } }
                                onInput={ event => {
                                    // Удаление телефона из массива
                                    let newP = [...est.phones];
                                    newP.splice(index, 1, event.target.value);

                                    setEst({
                                        ...est,
                                        phones: newP
                                    });
                                } }
                                />
                                <div className="setting__phone-remove"
                                     onClick={ () => {
                                         if (window.confirm('Вы действительно хотите удалить этот телефон?')) {

                                             let newPhones = [...est.phones];
                                             newPhones.splice(index, 1);

                                             dispatch(updateEstablishmentSagaAction({
                                                 field: 'phones',
                                                 value: JSON.stringify(newPhones)
                                             }));
                                         }
                                     } }
                                >Удалить</div>
                            </div>
                        );
                    })
                }
                <div className="setting__phone-wrapper">
                    <input type="text" className="input setting__phone" placeholder={ '+375 (29) 000 - 00 - 00' } onBlur={ event => {
                        dispatch(updateEstablishmentSagaAction({
                            field: 'phones',
                            value: JSON.stringify([...est.phones, event.target.value])
                        }));
                        event.target.value = '';
                    } }/>
                </div>
            </div>
            <div className="setting">
                <div className="setting__caption">Максимальное количество посетителей</div>
                <input type="text" className="input setting__attendance"
                       value={ est.attendance }
                       onInput={ event => {
                           setEst({
                               ...est,
                               attendance: event.target.value
                           });
                       } }
                       onBlur={ () => {
                           dispatch(updateEstablishmentSagaAction({
                               field: 'attendance',
                               value: est.attendance
                           }));
                       } }
                />
                <div className="setting__hint">Для отключения отображения заполненности зала, в мобильном приложении, <br/> установите значение «0» (ноль)</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Срок активации абонемента (в днях)</div>
                <input type="text" className="input setting__attendance"
                       value={ subscription_inactive_days }
                       onInput={ event => dispatch(subscriptionInactiveDaysAction(event.target.value)) }
                       onBlur={ () => dispatch(updateSubscriptionInactiveDaysSagaAction({ subscription_inactive_days })) }
                />
                <div className="setting__hint">По прошествии указанного количества дней, неактивированные абонементы будут удалятся</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Процент кэшбэка (указать число без «%»)</div>
                <input type="text"
                       className="input"
                       value={ est.points_rate }
                       onInput={ event => setEst({
                           ...est,
                           points_rate: event.target.value
                       }) }
                       onBlur={ () => dispatch(updateEstablishmentSagaAction({
                           field: 'points_rate',
                           value: est.points_rate
                       })) }
                />
                <div className="setting__hint">
                    <div>Укажите процент от потраченной суммы, который будет конвертироваться в баллы</div>
                    <div>Например: при 5% кэшбэка, за 10 рублей, потраченных в заведении, будет начислено 0.5 баллов</div>
                </div>
            </div>
            <div className="setting">
                <div className="setting__caption">Период отмены записи (указать число часов)</div>
                <input type="text"
                       className="input"
                       value={ est.time_to_unsubscribe }
                       onInput={ event => setEst({
                           ...est,
                           time_to_unsubscribe: event.target.value
                       }) }
                       onBlur={ () => dispatch(updateEstablishmentSagaAction({
                           field: 'time_to_unsubscribe',
                           value: est.time_to_unsubscribe
                       })) }
                />
                <div className="setting__hint">
                    <div>Отмена записи на групповое занятие, с привязанным абонементом, будет возможна</div>
                    <div>не позднее указанного количества часов до начала тренировки</div>
                    <div>Минимальное значение 1 час</div>
                </div>
            </div>
            <div className="setting">
                <div className="setting__caption">Продление абонемента (кол-во дней)</div>
                <input type="text"
                       className="input"
                       value={ est.extension_days }
                       onInput={ event => setEst({
                           ...est,
                           extension_days: event.target.value
                       }) }
                       onBlur={ () => dispatch(updateEstablishmentSagaAction({
                           field: 'extension_days',
                           value: est.extension_days
                       })) }
                />
                <div className="setting__hint">Количество дней, после истечения срока действия абонемента, в которое будет работать продление</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Количество тренировок в долг</div>
                <input type="text"
                       className="input"
                       value={ est.workout_debt_count }
                       onInput={ event => setEst({
                           ...est,
                           workout_debt_count: event.target.value
                       }) }
                       onBlur={ () => dispatch(updateEstablishmentSagaAction({
                           field: 'workout_debt_count',
                           value: est.workout_debt_count
                       })) }
                />
                <div className="setting__hint">Количество групповых занятий на которые можно записаться без абонемента, при автоматическом списании тренировок</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Количество пропущенных тренировок до блокировки</div>
                <input type="text"
                       className="input"
                       value={ est.missed_workout_count }
                       onInput={ event => setEst({
                           ...est,
                           missed_workout_count: event.target.value
                       }) }
                       onBlur={ () => dispatch(updateEstablishmentSagaAction({
                           field: 'missed_workout_count',
                           value: est.missed_workout_count
                       })) }
                />
                <div className="setting__hint">Это количество тренировок, когда клиент был записан и не явился на тренировку (не было отмечено его присутствие на занятии). При превышении количества неявок запись на групповые занятия будет невозможна.</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Реквизиты</div>
                <TextareaAutosize
                    className="input input--textarea"
                    value={ est.requisites }
                    onInput={ event => setEst({
                        ...est,
                        requisites: event.target.value
                    })}
                    onBlur={ () => {
                        dispatch(updateEstablishmentSagaAction({ field: 'requisites', value: est.requisites }));
                    } }
                />
            </div>
            <div className="setting">
                <div className="setting__caption">Сервис онлайн-платежей</div>
                <Select
                    current={
                        est.online_payment_service === 'bepaid' ? 'Bepaid'
                        : est.online_payment_service === 'yookassa' ? 'Yookassa'
                        : est.online_payment_service === '' ? 'Платежи отключены' : ''
                    }
                    type={ 'online_payment_service' }
                    options={ [{ id: '', name: 'Платежи отключены' }, { id: 'bepaid', name: 'Bepaid' }, { id: 'yookassa', name: 'Yookassa' }] }
                    handler={ elem => {
                        dispatch(updateEstablishmentSagaAction({
                            field: 'online_payment_service',
                            value: elem.id
                        }));
                        dispatch(selectAction(SELECT_INITIAL));
                    } }
                />
            </div>
            <div className="setting">
                <div className="setting__caption">Идентификатор магазина (store_id)</div>
                <input type="text" className="input"
                       value={ est.online_payment_store_id }
                       onInput={ event => setEst({
                           ...est,
                           online_payment_store_id: event.target.value
                       }) }
                       onBlur={ () => dispatch(updateEstablishmentSagaAction({
                           field: 'online_payment_store_id',
                           value: est.online_payment_store_id
                       })) }
                />
                <div className="setting__hint">Укажите идентификатор магазина, указанный в личном кабинете bepaid</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Секретный ключ (secret_key)</div>
                <input type="text" className="input"
                       value={ est.online_payment_secret_key }
                       onInput={ event => setEst({
                           ...est,
                           online_payment_secret_key: event.target.value
                       }) }
                       onBlur={ () => dispatch(updateEstablishmentSagaAction({
                           field: 'online_payment_secret_key',
                           value: est.online_payment_secret_key
                       })) }
                />
                <div className="setting__hint">Укажите секретный ключ, указанный в личном кабинете bepaid</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Адрес виджета</div>
                <div className="setting__ico-wrapper">
                    <Tippy content={ 'Скопировать ссылку' }>
                        <div className="setting__ico setting__ico--copy"
                             onClick={ () => {
                                 navigator.clipboard.writeText(est.widget);
                                 growl({ type: 'success', message: 'Ссылка скопирована' });
                             } }
                        />
                    </Tippy>
                </div>
                <div className="input input--copy">{ est.widget }</div>
                <div className="setting__hint">Адрес виджета, с помощью которого можно записаться на групповое занятие не устанавливая мобильное приложение.</div>
                <div className="setting__hint">Данную ссылку можно разместить на сайте или в социальных сетях</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Код для вставки виджета на сайт</div>
                <div className="setting__ico-wrapper">
                    <Tippy content={ 'Скопировать код виджета' }>
                        <div className="setting__ico setting__ico--copy"
                             onClick={ () => {
                                 navigator.clipboard.writeText(`<iframe width="100%" height="100%" id="iframe_schedule" style="border: none" src="${ est.widget }"></iframe>`);
                                 growl({ type: 'success', message: 'Код скопирован' });
                             } }
                        />
                    </Tippy>
                </div>
                <div className="input input--textarea">{ `<iframe width="100%" height="100%" id="iframe_schedule" style="border: none" src="${ est.widget }"></iframe>` }</div>
                <div className="setting__hint">Разместите этот код на вашем сайте, для возможности просмотра расписания и записи на групповые занятия через сайт</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Скрипт для определения высоты расписания</div>
                <div className="setting__ico-wrapper">
                    <Tippy content={ 'Скопировать код виджета' }>
                        <div className="setting__ico setting__ico--copy"
                             onClick={ () => {
                                 navigator.clipboard.writeText(`<script>window.addEventListener('message',event=>{if(event.origin!=='https://alga.by')return;document.getElementById('iframe_schedule').height=event.data+'px';});</script>`);
                                 growl({ type: 'success', message: 'Код скопирован' });
                             } }
                        />
                    </Tippy>
                </div>
                <div className="input input--textarea">{ `<script>window.addEventListener('message',event=>{if(event.origin!=='https://alga.by')return;document.getElementById('iframe_schedule').height=event.data+'px';});</script>` }</div>
                <div className="setting__hint">Разместите этот код на вашем сайте, для автоматического определения высоты блока с расписанием</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Ссылка на таблицу лидеров</div>
                <div className="setting__ico-wrapper">
                    <Tippy content={ 'Скопировать ссылку' }>
                        <div className="setting__ico setting__ico--copy"
                             onClick={ () => {
                                 navigator.clipboard.writeText(`https://alga.by/fitness_leaderboard?s=${ s }&m=1`);
                                 growl({ type: 'success', message: 'Ссылка скопирована' });
                             } }
                        />
                    </Tippy>
                </div>
                <div className="input input--copy">{ `https://alga.by/fitness_leaderboard?s=${ s }&m=1` }</div>
                <div className="setting__hint">На странице будут представлены первые 30 посетителей, которые посетили наибольшее количество занятий.</div>
            </div>
            <div className="setting">
                <div className="setting__caption">Прикреплённые документы (.pdf)</div>
                {
                    docs?.map((elem, index) => {
                        return (
                            <div key={ index } className="setting__doc">
                                <div className="setting__doc-content">
                                    <label className="setting__doc-file">
                                        <input type="file" onChange={ file => readFile({ input: file, id: index }) } />
                                        <div className="setting__doc-preview"/>
                                    </label>
                                    <input type="text" className="input"
                                           value={ elem.name }
                                           onInput={ event => {
                                               let newDocs = [...docs];
                                               newDocs[index] = { ...newDocs[index], name: event.target.value };

                                               dispatch(docsAction(newDocs));
                                           } }
                                           onBlur={ () => dispatch(updateEstablishmentSagaAction({
                                               field: 'docs',
                                               value: JSON.stringify(docs)
                                           })) }
                                    />
                                    <div className="setting__doc-remove"
                                         onClick={ () => {
                                             if (!window.confirm('Вы действительно хотите удалить документ?')) return;

                                             dispatch(updateEstablishmentSagaAction({
                                                 field: 'docs',
                                                 value: JSON.stringify([...docs].filter(el => el.name !== elem.name && el.link !== elem.link))
                                             }));
                                         } }
                                    >Удалить</div>
                                </div>
                                {
                                    elem.registration === 1 &&
                                    <div className="setting__doc-registration">
                                        <input type="text" className="input"
                                               value={ elem.registration_name }
                                               onInput={ event => {
                                                   let newDocs = [...docs];
                                                   newDocs[index] = { ...newDocs[index], registration_name: event.target.value };

                                                   dispatch(docsAction(newDocs));
                                               } }
                                               onBlur={ () => dispatch(updateEstablishmentSagaAction({
                                                   field: 'docs',
                                                   value: JSON.stringify(docs)
                                               })) }
                                        />
                                    </div>
                                }
                                <div className="setting__doc-buttons">
                                    <div
                                        className={ `setting__doc-button setting__doc-button--payment ${ elem.registration === 1 ? 'setting__doc-button--active' : '' }` }
                                        onClick={ () => {
                                            // Копируем docs
                                            let docsCopy = [...docs].map(el => {
                                                if (el.registration === 1) {
                                                    const { registration_name, registration, ...rest } = el;
                                                    return rest;
                                                }
                                                else if (el.link === elem.link && el.name === elem.name) {
                                                    return { ...el, registration: 1 };
                                                }
                                                else return el;
                                            });

                                            // Меняем флаг registration
                                            dispatch(updateEstablishmentSagaAction({
                                                field: 'docs',
                                                value: JSON.stringify(docsCopy)
                                            }));
                                        } }
                                    >Согласие при регистрации</div>
                                    <div
                                        className={ `setting__doc-button setting__doc-button--payment ${ elem.payments === 1 ? 'setting__doc-button--active' : '' }` }
                                        onClick={ () => {
                                            // Копируем docs
                                            let docsCopy = [...docs].map(el => {
                                                if (el.payments === 1) {
                                                    return { ...el, payments: 0 };
                                                }
                                                else if (el.link === elem.link && el.name === elem.name) {
                                                    return { ...el, payments: 1 };
                                                }
                                                else return el;
                                            });

                                            // Меняем флаг payments
                                            dispatch(updateEstablishmentSagaAction({
                                                field: 'docs',
                                                value: JSON.stringify(docsCopy)
                                            }));
                                        } }
                                    >Информация об оплате</div>
                                    <div
                                        className={ `setting__doc-button setting__doc-button--subscribe ${ elem.subscribe === 1 ? 'setting__doc-button--active' : '' }` }
                                        onClick={ () => {
                                            // Копируем docs
                                            let docsCopy = [...docs].map(el => {
                                                if (el.subscribe === 1) {
                                                    return { ...el, subscribe: 0 };
                                                }
                                                else if (el.link === elem.link && el.name === elem.name) {
                                                    return { ...el, subscribe: 1 };
                                                }
                                                else return el;
                                            });

                                            // Меняем флаг subscribe
                                            dispatch(updateEstablishmentSagaAction({
                                                field: 'docs',
                                                value: JSON.stringify(docsCopy)
                                            }));
                                        } }
                                    >Информация о подписке</div>
                                </div>
                            </div>
                        );
                    })
                }
                <div className={ `setting__doc-form ${ upload_file.link && 'setting__doc-form--file' }` }>
                    <div className="setting__doc">
                        <div className="setting__doc-content">
                            <label className="setting__doc-file">
                                <input type="file" onChange={ file => readFile({ input: file, id: 'add' }) } />
                                <div className="setting__doc-preview"/>
                            </label>
                            <input type="text" className="input"
                                   value={ upload_file.name }
                                   placeholder={ 'Название файла' }
                                   onInput={ event => dispatch(uploadFileAction({ ...upload_file, name: event.target.value })) }
                            />
                        </div>
                    </div>
                    <div className="setting__doc-add"
                        onClick={ () => {
                            dispatch(updateEstablishmentSagaAction({
                                field: 'docs',
                                value: JSON.stringify([...docs, upload_file])
                            }));
                        } }
                    >Добавить файл</div>
                </div>
            </div>
        </div>
    );
};

export default EstablishmentSettings;